//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const edit = () => import('./edit.vue');

export default {
  routes: [
    {
      path: '/market/v2025/indexAdmin',
      name: 'market_v2025_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/market/v2025/edit',
      name: 'market_v2025_edit',
      component: edit,
      meta: {public: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/marketEntity/v2025/router.js